import { lazy, Suspense, useState } from "react";
import useAccountInfo from "@/hooks/useAccountInfo";

const CalendarOnboardingTour = lazy(() =>
  import("./CalendarOnboardingTour").then((module) => ({
    default: module.CalendarOnboardingTour,
  })),
);

export function LazyCalendarOnboardingTour() {
  const isPending: boolean = useAccountInfo(
    (state) => state.accountInfo.onboardingTourPending ?? false,
  );

  // Latched: the celebration plays after the pending flag has already cleared.
  const [hasStarted, setHasStarted] = useState(isPending);
  if (isPending && !hasStarted) setHasStarted(true);

  if (!hasStarted) return null;

  return (
    <Suspense fallback={null}>
      <CalendarOnboardingTour />
    </Suspense>
  );
}
